export const buyingContext = [
  {
    id: 1,
    industry: 'Pharmaceuticals / Life Sciences ',
    description:
      'Company is expanding drug pipelines and adopting AI in R&D, but sales teams still struggle with compliance-heavy interactions and long rep ramp times',
  },
  {
    id: 2,
    industry: 'Healthcare Providers (Hospitals & Clinics)',
    description:
      'System is under pressure to reduce operating costs and improve patient outcomes. Physicians complain about vendor overload and limited time with reps',
  },
  {
    id: 3,
    industry: 'Biotechnology',
    description:
      'Biotech firm scaling rapidly, but commercial teams lack structured enablement. Scientific complexity makes product positioning difficult for new reps',
  },
  {
    id: 4,
    industry: 'Financial Services (Banking)',
    description:
      'Bank is modernizing digital channels while tightening compliance. Sales teams are bogged down with paperwork and struggle to cross-sell consistently',
  },
  {
    id: 5,
    industry: 'Insurance',
    description:
      'Insurer is battling high churn and competition from digital-first providers. Sales reps must explain complex policies clearly while handling high volumes of seasonal hires.',
  },
  {
    id: 6,
    industry: 'Retail',
    description:
      'Retailer is shifting toward e-commerce and omnichannel sales. Store associates need consistent messaging and faster onboarding to handle seasonal surges.',
  },
  {
    id: 7,
    industry: 'Telecommunications',
    description:
      'Telecom provider is rolling out 5G services but facing tough competition. Sales teams must simplify complex offerings and differentiate against price wars.',
  },
  {
    id: 8,
    industry: 'Technology (Software / SaaS)',
    description:
      'Tech firm is scaling fast but has inconsistent messaging across sales regions. Leadership wants faster ramp for SDRs and AEs and more consistent product demos',
  },
  {
    id: 9,
    industry: 'Manufacturing (Industrial Goods)',
    description:
      'Manufacturer is digitizing its sales approach. Complex product catalogs and long buying cycles make rep training slow and inconsistent',
  },
  {
    id: 10,
    industry: 'Energy (Oil, Gas, Renewables)',
    description:
      'Energy company is diversifying into renewables. Sales teams need help positioning new offerings while navigating regulatory requirements and long deal cycles.',
  },
  {
    id: 11,
    industry: 'Utilities',
    description:
      'Utility company is investing in smart grid and customer engagement tools. Sales and customer service reps must explain technical upgrades to non-technical customers',
  },
  {
    id: 12,
    industry: 'Transportation & Logistics',
    description:
      'Logistics provider is scaling with e-commerce growth. Sales teams must explain value in a highly commoditized market and adapt quickly to supply chain disruptions.',
  },
  {
    id: 13,
    industry: 'Real Estate (Commercial & Residential)',
    description:
      'Real estate firm faces volatile markets and rising competition from digital platforms. Agents need sharper value positioning and coaching to win deals.',
  },
  {
    id: 14,
    industry: ' Construction',
    description:
      'Construction firm is managing large, complex projects. Sales cycles are long, with multiple stakeholders and heavy emphasis on cost justification.',
  },
  {
    id: 15,
    industry: 'Hospitality & Travel',
    description:
      'Hotel and travel group is rebounding from pandemic disruptions. Sales teams must balance cost-sensitive buyers with the push for premium experiences.',
  },
  {
    id: 16,
    industry: 'Education (Higher Ed & EdTech)',
    description:
      'University is under pressure to boost enrollment and adopt digital tools. Admissions and outreach teams need consistent messaging and faster training.',
  },
  {
    id: 17,
    industry: 'Automotive',
    description:
      'Automaker is launching EV lines while balancing dealer relationships. Sales reps must explain technical features and handle customer hesitations around adoption.',
  },
  {
    id: 18,
    industry: 'Aerospace & Defense',
    description:
      'Defense contractor is dealing with long procurement cycles and strict compliance. Sales must align technical experts with government buyers',
  },
  {
    id: 19,
    industry: ' Media & Entertainment',
    description:
      'Media company is shifting from traditional to digital subscriptions. Sales teams must adapt messaging to advertisers and corporate partners in a competitive space.',
  },
  {
    id: 20,
    industry: 'Consumer Packaged Goods',
    description:
      'CPG company is battling shrinking margins and retailer pressure. Sales teams need better training to push premium products and upsell against store brands',
  },
  {
    id: 21,
    industry: 'Other',
    description:
      'The company is under pressure to improve efficiency and reduce costs while staying competitive. Leadership is exploring new technologies, including AI, but sales teams are juggling multiple priorities, inconsistent messaging, and limited time with customers. Any new solution must clearly show how it simplifies work, drives measurable ROI, and fits with existing tools.',
  },
];
